var $ca0549dfb1669363$exports = {};
$ca0549dfb1669363$exports = {
  "pending": "\u010Dek\xE1 na vy\u0159\xEDzen\xED"
};
export { $ca0549dfb1669363$exports as default };